import { render, staticRenderFns } from "./Subcategory.vue?vue&type=template&id=2ebd906a"
import script from "./Subcategory.vue?vue&type=script&lang=js"
export * from "./Subcategory.vue?vue&type=script&lang=js"
import style0 from "./Subcategory.vue?vue&type=style&index=0&id=2ebd906a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports